import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ReactTable6 from './engine/ReactTable6';
import buildColumns from './utils/buildColumns';
import resolveValue from './utils/resolveValue';
import { DEFAULT_MOCK_ROWS } from './Table.constants';

const getSubComponent = (expandable, context) => expandable?.SubComponent &&
  ((row) => expandable.SubComponent(row, context));

const Table = ({
  schema,
  context = {},
  data = [],
  isLoading = false,
  ...engineProps
}) => {
  const mockRows = resolveValue(schema.loading?.mockRows, context) ?? DEFAULT_MOCK_ROWS;
  const mockData = useMemo(() => [...Array(mockRows).keys()], [mockRows]);

  return (
    <ReactTable6
      styles={ schema.styles }
      columns={ buildColumns(schema, context) }
      data={ isLoading ? mockData : data }
      SubComponent={ getSubComponent(schema.expandable, context) }
      { ...schema.engineProps }
      { ...engineProps }
    />
  );
};

Table.propTypes = {
  schema: PropTypes.shape({
    id: PropTypes.string.isRequired,
    styles: PropTypes.array,
    columns: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
    ordering: PropTypes.object,
    normalizeWidths: PropTypes.bool,
    loading: PropTypes.shape({ mockRows: PropTypes.oneOfType([PropTypes.number, PropTypes.func]) }),
    expandable: PropTypes.shape({ SubComponent: PropTypes.func }),
    engineProps: PropTypes.object
  }).isRequired,
  context: PropTypes.object,
  data: PropTypes.array,
  isLoading: PropTypes.bool,
  isRowSelected: PropTypes.func,
  hideHeader: PropTypes.bool
};

export { default as buildColumns } from './utils/buildColumns';
export { default as fieldWidths } from './utils/fieldWidths';
export { default as useColumnResize } from './hooks/useColumnResize';

export default Table;
